export default __webpack_public_path__ + "static/media/pm-logo-default.ff153727.svg";